import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { GoodsActions } from './goods.actions';
import { GoodsService } from '../../services/goods.service';
import { extractErrorMessage } from '../../utils/error.utils';

@Injectable()
export class GoodsEffects {
  private actions$ = inject(Actions);
  private svc = inject(GoodsService);

  loadGoods$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GoodsActions.loadGoods),
      mergeMap(({ status }) => this.svc.getAll(status).pipe(
        map(goods => GoodsActions.loadGoodsSuccess({ goods })),
        catchError(err => of(GoodsActions.loadGoodsFailure({ error: extractErrorMessage(err) })))
      ))
    )
  );

  loadGood$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GoodsActions.loadGood),
      mergeMap(({ id }) => this.svc.getById(id).pipe(
        map(good => GoodsActions.loadGoodSuccess({ good })),
        catchError(err => of(GoodsActions.loadGoodFailure({ error: extractErrorMessage(err) })))
      ))
    )
  );

  createGood$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GoodsActions.createGood),
      mergeMap(({ dto }) => this.svc.create(dto).pipe(
        map(good => GoodsActions.createGoodSuccess({ good })),
        catchError(err => of(GoodsActions.createGoodFailure({ error: extractErrorMessage(err) })))
      ))
    )
  );

  updateGood$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GoodsActions.updateGood),
      mergeMap(({ id, dto }) => this.svc.update(id, dto).pipe(
        map(good => GoodsActions.updateGoodSuccess({ good })),
        catchError(err => of(GoodsActions.updateGoodFailure({ error: extractErrorMessage(err) })))
      ))
    )
  );

  deleteGood$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GoodsActions.deleteGood),
      mergeMap(({ id }) => this.svc.delete(id).pipe(
        map(() => GoodsActions.deleteGoodSuccess({ id })),
        catchError(err => of(GoodsActions.deleteGoodFailure({ error: extractErrorMessage(err) })))
      ))
    )
  );

  bulkImport$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GoodsActions.bulkImportGoods),
      mergeMap(({ file }) => this.svc.bulkImport(file).pipe(
        map(result => GoodsActions.bulkImportGoodsSuccess({ result })),
        catchError(err => of(GoodsActions.bulkImportGoodsFailure({ error: extractErrorMessage(err) })))
      ))
    )
  );
}
